export type PreferenceMetric =
  | "client_preferences_loaded_count"
  | "client_preferences_saved_count"
  | "client_learning_entry_created_count"
  | "preference_confirm_banner_shown_count"
  | "preference_confirm_banner_changed_count";

const shouldLogToConsole = () => process.env.NODE_ENV === "development";

const emitToGtag = (metric: PreferenceMetric, payload?: Record<string, any>) => {
  if (typeof window === "undefined") return;
  const gtag = (window as any)?.gtag;
  if (typeof gtag === "function") {
    gtag("event", metric, {
      event_category: "Preferences",
      ...payload,
    });
  }
};

export function trackPreferenceMetric(metric: PreferenceMetric, payload?: Record<string, any>) {
  try {
    emitToGtag(metric, payload);
    if (shouldLogToConsole()) {
      // eslint-disable-next-line no-console
      console.log("[metrics]", metric, payload || {});
    }
  } catch {
    // Never let analytics block the UI
  }
}
